import { Spin } from 'antd';
import React from 'react';
import { MarketplaceCollapse } from './MarketplaceCollapse';

const MarketplaceList = ({ filteredMarketplaces, isLoadingMarketplaces }) => {
  return (
    <Spin spinning={isLoadingMarketplaces}>
      <div
        style={{
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        {filteredMarketplaces?.map((marketplace) => (
          <MarketplaceCollapse key={marketplace.id} marketplace={marketplace} />
        ))}
      </div>
    </Spin>
  );
};

export default MarketplaceList;
